import { useNavigate, useParams } from 'react-router-dom'
import { useShareContext } from 'services/ShareContext';

interface IPublicPageProps {
    title: string;
    description: string;
    reasons: string[];
    helpCenterUrl?: string;
    imageUrl?: string;
    buttonTitle?: string;
}

export const PublicPage = (props: IPublicPageProps): JSX.Element => {
    const { setStatusCode } = useShareContext();
    const navigate = useNavigate();
    const { harid } = useParams<{ harid?: string }>();
    const { title, description, reasons, helpCenterUrl, imageUrl, buttonTitle } = props;

    const goToHomeOrListingPage = () => {
        setStatusCode(200);
        navigate(harid ? `/listing/${harid}` : '/', { replace: true });
    }

    return (
        <div className="container">
            <div className="row" style={{ minHeight: 'calc(100vh - 460px)' }}>
                <div className="col-12 align-self-center text-center h-100">
                    <div className="border-bottom ml-auto mr-auto pb-3 mb-5 pt-5" style={{ maxWidth: '1070px' }}>
                        <img
                            className="img-fluid mb-5 mt-4"
                            src={imageUrl || "https://content.harstatic.com/media/artwork/img_404.svg"}
                            alt="public page"
                        />
                        <h1 className="mb-5 mt-3 h1--larger" tabIndex={0}>
                            {title}
                        </h1>
                        <div className="pb-4 mb-2 font_size--large">
                            {description}{' '}
                            <a href={helpCenterUrl || "https://cms.har.com/help-center/"} target="_blank" rel="noopener noreferrer">Help Center</a>.
                        </div>
                        <div className="ml-auto mr-auto d-inline-block">
                            <div className="row">
                                <div className="col-md-auto col-12 text-center">
                                    <button onClick={goToHomeOrListingPage} className="btn btn--primary btn--large mb-3">{buttonTitle || "Back To Home"}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ml-auto mr-auto font_size--large text-left pb-5 mb-4" style={{ maxWidth: '586px' }}>
                        This could be because:
                        <ul className="list--black pt-2">
                            {reasons.map((reason, index) => (
                                <li key={index}>{reason}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}
